export default "__VITE_ASSET__NTanPqoL__"